import analyticsTrack from 'Common/utils/analytics'

const getAnalyticsData = ({ contentType, contentId, contentTitle }) => {
  return {
    eventName: 'Added content to kanban',
    contentId,
    contentTitle,
    contentType,
  }
}

export default function trackAddcontentToClass({
  contentType,
  contentId,
  contentTitle,
  destinationColumn,
  destinationClassId,
}) {
  const analyticsData = getAnalyticsData({
    contentType,
    contentId,
    contentTitle,
  })

  const { eventName } = analyticsData

  delete analyticsData.eventName

  analyticsTrack(eventName, {
    destinationColumn,
    destinationClassId,
    ...analyticsData,
  })
}
